import React, { useState, useEffect, useRef, useContext } from "react";
import { Bar } from 'react-chartjs-2';
import axios from "axios";
import { Typography, Avatar, Input, DatePicker, Modal, Button, Menu, Col, Row, message, ConfigProvider, Checkbox, Tab, Carousel, Space, Tag } from "antd";
import { Link, useParams, useNavigate, json } from "react-router-dom";
import { InboxOutlined, PlusOutlined, UserOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import './css/TableTitle.css'
import AdminStudentModal from "./components/AdminStudentModal";
import NewTable from "./components/NewTable";
import Label_language from '../language';
import { parse } from "@fortawesome/fontawesome-svg-core";
import BindLineId from "../login/BindLineId";
import BillPaymentGradeClassStudentChangeModal from "./components/BillPayment/views/BillPaymentGradeClassStudentChangeModal"
import CombinedCharts from './components/StudentBarChart';

const { RangePicker } = DatePicker;
const { Title } = Typography;
const label_language = Label_language.ems.children
const StudentList = () => {
    // const BarChart = () => {
    //     const BarChartData = {
    //       labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //       datasets: [
    //         {
    //           label: 'Monthly Sales',
    //           backgroundColor: 'rgba(75,192,192,0.4)',
    //           borderColor: 'rgba(75,192,192,1)',
    //           borderWidth: 1,
    //           hoverBackgroundColor: 'rgba(75,192,192,0.6)',
    //           hoverBorderColor: 'rgba(75,192,192,1)',
    //           BarChartData : [65, 59, 80, 81, 56, 55, 40],
    //         },
    //       ],
    //     };
      
    //     const options = {
    //       scales: {
    //         y: {
    //           beginAtZero: true,
    //         },
    //       },
    //     };
    // };  
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const ref = useRef(0);
    const [importData, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [language_time, set_language_time] = useState([]);
    const [search_date, set_search_date] = useState([null, null])
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [datas, setDatas] = useState();
    const [force_reload, set_force_reload] = useState(0)
    const [loading, set_loading] = useState(0)
    const [upload_modal, set_upload_modal] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [emergency_contact, set_emergency_contact] = useState([]);
    const [title, setTitle] = useState();
    const [people, setPeople] = useState(null);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [data, setData] = useState([]);
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const { confirm } = Modal;
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [wait_loading, set_wait_loading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [default_column, set_default_column] = useState([
        {
            title: '照片',
            fixed: 'left',
            sorter: false,
            render: (text, record, index) => (<>
                <div
                    style={{
                        margin: 0,
                        maxHeight: '64px',
                        width: '64px',
                    }}
                >
                    <Carousel
                        autoplay
                    >
                        {record['file_url'] ? record['file_url'].map((tmp, index) => (<>
                            <div>
                                <Avatar size={64} src={tmp} />
                            </div>
                        </>)) : (<>
                            <div>
                                <Avatar size={64} icon={<UserOutlined />} />
                            </div>
                        </>)}
                    </Carousel>
                </div>
            </>),
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.std_number[language],
        //     key: 'std_number',
        //     dataIndex: 'std_number',
        //     align: 'center',
        //     fixed: 'left',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.serial_name[language],
            key: 'serial_name',
            dataIndex: 'serial_name',
            align: 'center',
            fixed: 'left',
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.name[language],
            key: 'name',
            dataIndex: 'name',
            align: 'center',
            fixed: 'left',
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.is_free_tuition[language],
            key: 'is_free_tuition',
            dataIndex: 'is_free_tuition',
            align: 'center',
            // fixed: 'left',
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.grade_name[language],
            key: 'grade_name',
            dataIndex: 'grade_name',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.gender[language],
        //     key: 'gender',
        //     dataIndex: 'gender',
        //     align: 'center',
        //     // fixed: 'left',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.birthday[language],
            key: 'birthday',
            dataIndex: 'birthday',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.county[language],
        //     key: 'county',
        //     dataIndex: 'county',
        //     align: 'center',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.school[language],
            key: 'school',
            dataIndex: 'school',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.school_u_work_at[language],
        //     key: 'school_u_work_at',
        //     dataIndex: 'school_u_work_at',
        //     align: 'center',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.phone[language],
            key: 'phone',
            dataIndex: 'phone',
            align: 'center',
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.name_english[language],
            key: 'name_english',
            dataIndex: 'name_english',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.subject[language],
        //     key: 'subject',
        //     dataIndex: 'subject',
        //     align: 'center',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.email[language],
            key: 'email',
            dataIndex: 'email',
            align: 'center',
            fixed: 'left',
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.phone_home[language],
            key: 'phone_home',
            dataIndex: 'phone_home',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.listening[language],
        //     key: 'listening',
        //     dataIndex: 'listening',
        //     align: 'center',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.study_time_start[language],
        //     key: 'study_time_start',
        //     dataIndex: 'study_time_start',
        //     align: 'center',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.speaking[language],
            key: 'speaking',
            dataIndex: 'speaking',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.study_time_end[language],
        //     key: 'study_time_end',
        //     dataIndex: 'study_time_end',
        //     align: 'center',
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.reading[language],
            key: 'reading',
            dataIndex: 'reading',
            align: 'center',
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.address[language],
            key: 'address',
            dataIndex: 'address',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.writing[language],
        //     key: 'writing',
        //     dataIndex: 'writing',
        //     align: 'center',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.serial_name[language],
        //     key: 'serial_name',
        //     dataIndex: 'serial_name',
        //     align: 'center',
        //     fixed: 'left',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.name[language],
        //     key: 'name',
        //     dataIndex: 'name',
        //     align: 'center',
        //     fixed: 'left',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.email[language],
        //     key: 'email',
        //     dataIndex: 'email',
        //     align: 'center',
        //     fixed: 'left',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.phone[language],
        //     key: 'phone',
        //     dataIndex: 'phone',
        //     align: 'center',
        // },
        {
            title: 'Line ID',
            key: 'line_id',
            dataIndex: 'line_id',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.emergency_contact_name[language],
        //     sorter: false,
        //     align: 'center',
        //     key: ['emergency_contact', 'emergency_contact_name'],
        //     multiple: true,
        //     render: (text, record, index) => (
        //         record.emergency_contact.length != 0 && record.emergency_contact.map((item) => (
        //             <>
        //                 <p>{item.emergency_contact_name}</p>
        //             </>

        //         ))
        //     )
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.emergency_contact_phone_number[language],
        //     sorter: false,
        //     align: 'center',
        //     key: ['emergency_contact', 'emergency_contact_phone_number'],
        //     multiple: true,
        //     render: (text, record, index) => (
        //         record.emergency_contact.length != 0 && record.emergency_contact.map((item) => (
        //             <>
        //                 <p>{item.emergency_contact_phone_number}</p>
        //             </>
        //         ))
        //     )
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.relation_name[language],
        //     sorter: false,
        //     align: 'center',
        //     key: ['emergency_contact', 'relation_name'],
        //     multiple: true,
        //     render: (text, record, index) => (
        //         record.emergency_contact.length != 0 && record.emergency_contact.map((item) => {
        //             if (item.relation_name) {
        //                 return (
        //                     <>
        //                         <p>{item.relation_name}</p>
        //                     </>
        //                 )
        //             } else {
        //                 return (
        //                     <>
        //                         <p>-</p>
        //                     </>
        //                 )
        //             }
        //         })
        //     )
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.emergency_contact_line_id[language],
        //     sorter: false,
        //     align: 'center',
        //     key: ['emergency_contact', 'emergency_contact_line_id'],
        //     multiple: true,
        //     render: (text, record, index) => (
        //         record.emergency_contact.length != 0 && record.emergency_contact.map((item) => {
        //             if (item.relation_name) {
        //                 return (
        //                     <>
        //                         <p>{item.emergency_contact_line_id}</p>
        //                     </>
        //                 )
        //             } else {
        //                 return (
        //                     <>
        //                         <p>-</p>
        //                     </>
        //                 )
        //             }
        //         })
        //     )
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.emergency_contact_email[language],
        //     sorter: false,
        //     align: 'center',
        //     key: ['emergency_contact', 'emergency_contact_email'],
        //     multiple: true,
        //     render: (text, record, index) => (
        //         record.emergency_contact.length != 0 && record.emergency_contact.map((item) => {
        //             if (item.relation_name) {
        //                 return (
        //                     <>
        //                         <p>{item.emergency_contact_email}</p>
        //                     </>
        //                 )
        //             } else {
        //                 return (
        //                     <>
        //                         <p>-</p>
        //                     </>
        //                 )
        //             }
        //         })
        //     )
        // },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.note[language],
            key: 'note',
            dataIndex: 'note',
            align: 'center',
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.student_class[language],
        //     sorter: false,
        //     key: 'student_class',
        //     render: (text, record, index) => (
        //         record.student_class && record.student_class.map((item) => {
        //             if (item.class_name) {
        //                 return (
        //                     <>
        //                         <p>{item.class_name}</p>
        //                     </>
        //                 )
        //             } else {
        //                 return (
        //                     <>
        //                         <p>-</p>
        //                     </>
        //                 )
        //             }
        //         })
        //     ),
        //     align: 'center',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.student_class[language],
        //     sorter: false,
        //     key: 'grade_class_student_data',
        //     render: (text, record, index) => (
        //         record?.grade_class_student_data && record?.grade_class_student_data.map((item) => {
        //             if (item.class_name) {
        //                 return (
        //                     <>
        //                         <p>{item.class_name}</p>
        //                     </>
        //                 )
        //             } else {
        //                 return (
        //                     <>
        //                         <p>-</p>
        //                     </>
        //                 )
        //             }
        //         })
        //     ),
        //     align: 'center',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.rfid[language],
        //     sorter: false,
        //     key: 'rfid',
        //     render: (text, record, index) => (
        //         record?.user_external_token_data && record?.user_external_token_data.map((item) => {
        //             if (item.user_external_token_token) {
        //                 return (
        //                     <>
        //                         <p>{item.user_external_token_token}</p>
        //                     </>
        //                 )
        //             } else {
        //                 return (
        //                     <>
        //                         <p>-</p>
        //                     </>
        //                 )
        //             }
        //         })
        //     ),
        //     align: 'center',
        // },
        {
            title: '綁定狀態',
            sorter: false,
            disabled: true,

            key: 'binding_status',
            render: (text, record, index) => {
                let binding_status = record?.binding_status
                let binding_status_notify = record?.binding_status_notify
                let node = []
                if (!!binding_status) {
                    node.push(<Tag color="green">
                        已綁定Line
                    </Tag>)
                }
                else {
                    node.push(<Tag color="red">
                        未綁定Line
                    </Tag>)
                }
                if (!!binding_status_notify) {
                    node.push(<Tag color="green">
                        已綁定Line通知
                    </Tag>)
                }
                else {
                    node.push(<Tag color="red">
                        未綁定Line通知
                    </Tag>)
                }
                return <Space>{node.map(item => item)}</Space>
            },
            showType: ['家長', '行政', '老師',]
        },
        {
            title: label_language.basic_data_maintain_management.children.StudentList.children.line_user_id[language],
            key: "user_id",
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return (<>
                    <BindQRcode
                        key={`${index}`}
                        userId={record?.user_id}
                        onSuccess={() => reload()}
                    />

                </>)
            },
            showType: ['家長', '行政', '老師',]
        },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.is_free_tuition[language],
        //     sorter: false,
        //     key: 'is_free_tuition',
        //     render: (text, record, index) => {
        //         return (<>
        //             {record.is_free_tuition === 1 ? '是' : '否'}
        //         </>)
        //     },
        //     align: 'center',
        // },
        // {
        //     title: label_language.basic_data_maintain_management.children.StudentList.children.installment_count[language],
        //     sorter: false,
        //     key: 'installment_count',
        //     dataIndex: 'installment_count',
        //     align: 'center',
        // },
        // {
        //     title: '目前上課教室',
        //     sorter: false,
        //     align: 'center',
        // },
        // {
        //     title: '上課中',
        //     sorter: false,
        //     align: 'center',
        // },
        // {
        //     title: '填寫資料',
        //     sorter: false,
        //     align: 'center',
        //     render: (text, record, index) => (
        //         <>
        //             <Button type="primary" onClick={e => handleCopy(record.student_id)}>複製連結</Button>
        //         </>
        //     )
        // },
        {
            title: '操作',
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEditRow(record)}>編輯</Button>
                    <Button type="text" style={{ color: 'red' }} onClick={(e) => showMessage(record.student_id)}>刪除</Button>
                </>
            )
        },
    ]);
    const handleCopy = (id) => {
        // const textToCopy = `https://www.orange-technic.com:7444/cramSchool/StudentEnroll/${id}`;
        const textToCopy = `https://mercyenglishcenter.orange-technic.com/cramSchool/StudentEnroll/${id}`;
        navigator.clipboard.writeText(textToCopy);
        messageApi.open({
            type: 'success',
            content: '已複製成功！',
        });
    }
    const handleEdit = (file_id) => {
        if (!editcard?.
            // installment_count || editcard.name == undefined || editcard.phone == undefined || editcard.grade_id == undefined || editcard.email == undefined || editcard.name == '' || editcard.phone == '' || editcard.grade_id == '' || editcard.email == ''
            editcard.name == undefined || editcard.phone == undefined || editcard.grade_name == undefined || editcard.email == undefined || editcard.name == '' || editcard.phone == '' || editcard.grade_name == '' || editcard.email == '' || editcard.serial_name == undefined || editcard.serial_name == ''
                || editcard.name_english == undefined || editcard.birthday == undefined || editcard.school == undefined 
                || editcard.name_english == '' || editcard.birthday == '' || editcard.school == '' 
            ) {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '請完整填寫必填欄位４５',
            });
        }
        else if (editcard?.installment_count < 1) {
            messageApi.open({
                type: 'error',
                content: '分期期數最小為1',
            });
        }
        else {
            let data_tmp = { ...editcard };
            let emergency_contact_tmp = emergency_contact && emergency_contact.map((item) => {
                if (item.relation_id == '其他') {
                    return ({
                        key: item.key,
                        id: item.emergency_contact_id,
                        emergency_contact_name: item.emergency_contact_name,
                        emergency_contact_phone_number: item.emergency_contact_phone_number,
                        relation_name: item.relation_name,
                        emergency_contact_line_id: item.emergency_contact_line_id
                    })
                } else {
                    return ({ ...item })
                }
            })
            data_tmp['emergency_contact'] = emergency_contact_tmp;
            data_tmp['file_id'] = file_id;
            data_tmp['grade_class_student_data'] = editcard?.grade_class_student_data
            axios
                .patch(`/cramSchool/api/student`, [data_tmp])
                .then((response) => {
                    if (response.data.status === 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        reload();
                    }
                })
        }
    }
    const handleSubmit = (file_id) => {
        let emergency_contact_tmp = emergency_contact && emergency_contact.map((item) => {
            if (item.relation_id == '其他') {
                return ({
                    key: item.key,
                    emergency_contact_name: item.emergency_contact_name,
                    emergency_contact_phone_number: item.emergency_contact_phone_number,
                    relation_name: item.relation_name,
                    emergency_contact_line_id: item.emergency_contact_line_id
                })
            } else {
                return ({ ...item })
            }
        })
        let data_arr = handle_pre_post(editcard, emergency_contact_tmp, file_id)
        if (data_arr) {
            data_arr['grade_class_student_data'] = (editcard?.grade_class_student_data) ?? []
            handle_post([data_arr])
        }
    }
    const handle_pre_post = (editcard_, emergency_contact_, file_id_ = []) => {
        if (editcard_.serial_name_make == true) {
            if (!editcard?.installment_count || editcard_.name == undefined || editcard_.phone == undefined || editcard_.grade_name == undefined || editcard_.email == undefined || editcard_.name == '' || editcard_.phone == '' || editcard_.grade_name == '' || editcard_.email == '') {
                // setOpen(false);
                messageApi.open({
                    type: 'error',
                    content: '請完整填寫必填欄位',
                });
            } else {
                let data_tmp = { ...editcard_, emergency_contact: emergency_contact_, file_id: file_id_ };
                return data_tmp;
            }
        }
        else if (editcard?.installment_count < 1) {
            messageApi.open({
                type: 'error',
                content: '分期期數最小為1',
            });
        }
        else {
             if (editcard_.name == undefined || editcard_.phone == undefined || editcard_.grade_name == undefined || editcard_.email == undefined || editcard_.name == '' || editcard_.phone == '' || editcard_.grade_name == '' || editcard_.email == '' || editcard_.serial_name == undefined || editcard_.serial_name == ''
                || editcard_.name_english == undefined || editcard_.birthday == undefined || editcard_.school == undefined 
                || editcard_.name_english == '' || editcard_.birthday == '' || editcard_.school == '' 
            ) {
                // setOpen(false);
                messageApi.open({
                    type: 'error',
                    content: '請完整填寫必填欄位',
                });
            // if (editcard_.name == undefined || editcard_.std_number == undefined || editcard_.gender == undefined || editcard_.phone == undefined || editcard_.email == undefined|| editcard_.county == undefined || editcard_.school_u_work_at == undefined || editcard_.subject == undefined || editcard_.listening == undefined || editcard_.speaking == undefined || editcard_.reading == undefined || editcard_.writing == undefined 
            //     || editcard_.name == '' || editcard_.std_number == '' || editcard_.county == '' || editcard_.gender == '' || editcard_.phone == '' || editcard_.email == '' || editcard_.school_u_work_at == '' || editcard_.subject == '' || editcard_.listening == '' || editcard_.speaking == '' || editcard_.reading == '' || editcard_.writing == '' ) {
            //     messageApi.open({
            //         type: 'error',
            //         content: '請完整填寫必填欄位',
            //     });
            } else {
                let data_tmp = {
                    ...editcard_,
                    emergency_contact: emergency_contact_,
                    file_id: file_id_
                };
                return data_tmp;
            }
        }

    }
    const handle_post = (data_arr) => {
        axios
            .post(`/cramSchool/api/student`, data_arr)
            .then((response) => {
                let responseData = response.data
                // console.log(responseData)
                if (response.data.status == 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                } else {
                    if(!!responseData?.duplicate_name){
                        messageApi.open({
                            type: 'error',
                            content: '姓名與email重複，請更換一個email輸入',
                        });
                    }
                    else{
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        reload();
                    }
                  
                }
            })
    }
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/student`, {
                data: [{ student_id: value }]
            })
            .then((response) => {
                if (response.data.status != 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    reload();
                }
            })
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'student_id': value })
            })
            // console.log(deleterow)
            axios
                .delete(`/cramSchool/api/student`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnEditRow = (record) => {
        setTitle('修改學生');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        set_emergency_contact(record?.emergency_contact);
        let class_id = []
        class_id = (record?.grade_class_student_data ?? []).map((value) => {
            return value?.class_id
        })
        setEditCard({
            ...record,
            class_id
        });
    }
    const handleOnAddRow = () => {
        setTitle('新增學生');
        setColor('d65b77');
        setEdit(false);
        set_emergency_contact([]);
        setEditCard({});
        setOpen(true);
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        set_custom_filter_value(param?.keyword);
        
        if ((checklist || []).some((ele) => {
            return ele.includes("emergency_contact")
        })) {
            checklist.push("emergency_contact")
        }


        return axios
            .get('/cramSchool/api/student', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    study_time_start: search_date[0],
                    study_time_end: search_date[1],
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
                get_picture(response.data.data);
                setPeople(response.data.people);
            })
            .finally(() => {
                set_loading(false)
            })
    }

    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let student_id = value['student_id']
            // console.log(student_id);
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (student_id == value.student_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    useEffect(() => {
        reload();
    }, [search_date])

    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'student',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'student'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        // getData();
    }, []);
    useEffect(() => {
        // console.log(data)
        data.forEach(each_item => {
            if (each_item.student_id === editcard.student_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [data])
    const handleExport = () => {
        // let language_tmp = JSON.stringify(default_column);
        let language_tmp = [];
        language_time && language_time.map((item) => {
            let value = label_language.basic_data_maintain_management.children.StudentList.children[`${item}`];
            if (value != undefined) {
                language_tmp.push(JSON.stringify({ [`${item}`]: value }));
            }
        })
        // language_tmp.push(
        //     JSON.stringify({ address: { "zh-tw": "地址", en: "address" } })
        //     , JSON.stringify({ email: { "zh-tw": "Email", en: "email" } })
        //     // , JSON.stringify({  file_id:{"zh-tw":"file_id",en:"file_id"}   })
        //     , JSON.stringify({ emergency_contact_phone_number: { "zh-tw": "緊急聯絡人", en: "emergency_contact" } })
        //     , JSON.stringify({ emergency_contact_name: { "zh-tw": "緊急聯絡人", en: "emergency_contact" } })
        //     // , JSON.stringify({  grade_id:{"zh-tw":"grade_id",en:"grade_id"}   })
        //     , JSON.stringify({ grade_name: { "zh-tw": "當前年級", en: "grade_name" } })
        //     , JSON.stringify({ json_data: { "zh-tw": "json_data", en: "json_data" } })
        //     , JSON.stringify({ key: { "zh-tw": "key", en: "key" } })
        //     , JSON.stringify({ name: { "zh-tw": "姓名", en: "name" } })
        //     , JSON.stringify({ name_english: { "zh-tw": "英文姓名", en: "name_english" } })
        //     , JSON.stringify({ note: { "zh-tw": "備註", en: "note" } })
        //     , JSON.stringify({ phone: { "zh-tw": "手機號碼", en: "phone" } })
        //     , JSON.stringify({ school: { "zh-tw": "學校", en: "school" } })
        //     , JSON.stringify({ serial_name: { "zh-tw": "學號", en: "serial_name" } })
        //     // , JSON.stringify({  student_class:{"zh-tw":"student_class",en:"student_class"}   })
        //     // , JSON.stringify({  student_id:{"zh-tw":"student_id",en:"student_id"}   })
        //     // , JSON.stringify({  study_time_start:{"zh-tw":"就學時間（起）",en:"study_time_start"}   })
        //     // , JSON.stringify({  study_time_end:{"zh-tw":"就學時間（迄）",en:"study_time_end"}   })
        // )
        // console.log(language_tmp);
        language_tmp.push(
            JSON.stringify({ serial_name: { "zh-tw": "學號", en: "serial_name" } })
            , JSON.stringify({ name: { "zh-tw": "姓名", en: "name" } })
            , JSON.stringify({ is_free_tuition: { "zh-tw": "班別", en: "class" } })
            , JSON.stringify({ grade_name: { "zh-tw": "性/別", en: "gender" } })
            , JSON.stringify({ birthday: { "zh-tw": "居住縣市", en: "county" } })
            , JSON.stringify({ school: { "zh-tw": "服務學校", en: "school" } })
            , JSON.stringify({ name_english: { "zh-tw": "任教科目", en: "subject" } })
            , JSON.stringify({ phone: { "zh-tw": "手機號碼", en: "phone" } })
            , JSON.stringify({ email: { "zh-tw": "Email", en: "email" } })
            , JSON.stringify({ phone_home: { "zh-tw": "聽", en: "listening" } })
            , JSON.stringify({ speaking: { "zh-tw": "說", en: "speaking" } })
            , JSON.stringify({ reading: { "zh-tw": "讀", en: "reading" } })
            , JSON.stringify({ address: { "zh-tw": "寫", en: "writing" } })
            , JSON.stringify({ note: { "zh-tw": "備註", en: "note" } })
            // , JSON.stringify({  file_id:{"zh-tw":"file_id",en:"file_id"}   })
            // , JSON.stringify({ emergency_contact_phone_number: { "zh-tw": "緊急聯絡人", en: "emergency_contact" } })
            // , JSON.stringify({ emergency_contact_name: { "zh-tw": "緊急聯絡人", en: "emergency_contact" } })
            // , JSON.stringify({  grade_id:{"zh-tw":"grade_id",en:"grade_id"}   })
            , JSON.stringify({ json_data: { "zh-tw": "json_data", en: "json_data" } })
            , JSON.stringify({ key: { "zh-tw": "key", en: "key" } })
            // , JSON.stringify({  student_class:{"zh-tw":"student_class",en:"student_class"}   })
            // , JSON.stringify({  student_id:{"zh-tw":"student_id",en:"student_id"}   })
            // , JSON.stringify({  study_time_start:{"zh-tw":"就學時間（起）",en:"study_time_start"}   })
            // , JSON.stringify({  study_time_end:{"zh-tw":"就學時間（迄）",en:"study_time_end"}   })
        )
        console.log(language_tmp);

        axios
            .get('/cramSchool/api/student_excel', {
                responseType: 'blob',
                params: {
                    custom_filter_key: choose_column,
                    custom_filter_value: custom_filter_value,
                    language: language_tmp
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '學生名單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handleImportModal = (e) => {
        set_upload_modal(true);
    }
    const handleImport = (e) => {
        set_wait_loading(true);
        const files = e.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', choose_column);
        form_data.append('default_column', JSON.stringify(default_column));
        axios
            .post(`/cramSchool/api/student_import/read_sample`, form_data)
            .then((response) => {
                set_upload_modal(false);
                if (JSON.stringify(response.data.duplicate) != '') {
                    let data_tmp = []
                    response.data.duplicate.map((item) => {
                        if (item['emergency_contact'] == undefined) {
                            data_tmp.push({ ...item, emergency_contact: [] })
                        } else {
                            return (
                                data_tmp.push(item)
                            )

                        }
                    })
                    setImportData(data_tmp);
                } else {
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
                set_wait_loading(false)
                // if (response.data.status == 'failure') {
                //     setOpen(false);
                //     messageApi.open({
                //         type: 'error',
                //         content: '新增失敗',
                //     });
                //     reload();
                // } else {
                //     setOpen(false);
                //     messageApi.open({
                //         type: 'success',
                //         content: '新增成功',
                //     });
                //     reload();
                // }
            })
    }
    const handleDownload = () => {
        axios
            .get('/cramSchool/api/admin/manual/student?manual_id=2', {
                responseType: 'blob',
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '學生名單範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handleOver = (record) => {
        axios
            .patch(`/cramSchool/api/student`, record)
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '覆蓋失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '覆蓋成功',
                    });
                    record && record.map((value) => {
                        setImportData(importData.filter(item => (item.name != value.name) && (item.email != value.email)))
                    })
                    reload();
                }
            })
    }
    const handleReserve = (record) => {
        axios
            .post('/cramSchool/api/student/cover_email', record)
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '保留失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '保留成功',
                    });
                    reload();
                }
            })
    }
    const handleQRcodeNotifyPdf = () => {
        setPdfLoading(true)
        axios
            .get('/cramSchool/api/student/qrcode/pdf', {
                params: {
                    vertical: true,
                    // grade_class_id: search?.grade_class_id,
                    ...{
                        // custom_filter_key: checklist,
                        // custom_filter_value: param?.keyword,
                        study_time_start: search_date[0],
                        study_time_end: search_date[1],
                    }
                },
                method: 'GET',
                responseType: 'blob',
            })

            .then(response => {
                const href = URL.createObjectURL(response.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', '學生QRcode.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .finally(() => {
                setPdfLoading(false)
            })
    }
    return (
        <>
            <Col>學生總人數：{people}人</Col>

            <div>
               
                <CombinedCharts/>
        
            </div>
             
        
            {contextHolder}
            {/* <BillPaymentGradeClassStudentChangeModal /> */}
            <AdminStudentModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                emergency_contact={emergency_contact}
                set_emergency_contact={set_emergency_contact}
                setEditCard={setEditCard}
                data={data}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
            />
            <Row align={'end'} style={{ paddingTop: '10px' }}>
                {/* <Col>學生總人數：{people}人</Col> */}
                <Col span={24} >
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'StudentList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add_button_title={'新增學生'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'student_id'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        // rangepicker_title={'就學時間'}
                        // handleSearchDate={handleSearchDate}//搜尋日期
                        export={true}
                        import={true}
                        handleExport={handleExport}
                        handleImportModal={handleImportModal}
                        // language_time={language_time}
                        // set_language_time={set_language_time}
                        handleImport={handleImport}
                        handleDownload={handleDownload}
                        set_upload_modal={set_upload_modal}
                        upload_modal={upload_modal}
                        setImportData={setImportData}
                        importData={importData}
                        handleOver={handleOver}
                        handleReserve={handleReserve}
                        import_modal={import_modal}
                        set_import_modal={set_import_modal}
                        wait_loading={wait_loading}
                        qrcodeNotifyPdf={true}
                        handleQRcodeNotifyPdf={handleQRcodeNotifyPdf}
                        qrcodeNotifyLoading={pdfLoading}
                    ></NewTable>
                </Col>
            </Row >
        </>

    );
};
export default StudentList;


const BindQRcode = ({
    onSuccess = () => {

    },
    userId
}) => {
    const [show, setShow] = useState(false)
    useEffect(() => {
        setShow(false)
    }, [userId])
    return (
        <Space direction="vertical">
            <Button
                size="small"
                onClick={() => {
                    setShow(pre => !pre)
                }}>
                {show ? "隱藏" : "顯示"}
            </Button>

            {show &&
                <BindLineId
                    userId={userId}
                    onSuccess={onSuccess}
                />}
        </Space>
    )
}